import { captureMessage } from '@sentry/remix';
import { screenBrand } from '~/module/brand/brand';
import { screenTenantID } from '~/module/tenant/tenant';

/**
 * 同じ画面で繰り返し記録しないための印。ブランドの解決結果は画面のライフサイクル内で
 * 変わらないため、1回記録できれば足りる（毎レンダリングで送るとノイズになる）。
 */
let reported = false;

/**
 * ブランドを解決できなかったことを異常として記録する。
 *
 * テナントが定まったのにブランド値を取得できない場合、画面は既定テナントのブランドで
 * 表示してユーザーの操作を妨げない（可用性を優先）。一方でそれは設定不備であり、
 * 気づけないまま OEM テナントのユーザーにプラットフォームのブランドを見せ続けることに
 * なるため、検知できる形で残す（D13・tasks 3.1.1）。
 */
export const reportUnresolvedBrand = (): void => {
  if (reported) {
    return;
  }
  if (!screenBrand().unresolved) {
    return;
  }
  reported = true;
  captureMessage('failed to resolve brand for the screen tenant', {
    level: 'error',
    tags: { tenant_id: screenTenantID() },
  });
};
